import React from 'react';
import { SearchMaterial } from '../Types/SearchResult';
import { MaterialItem, MaterialItemDisabled } from '../Styles/Search';
import MaterialIconProvider from '../../Material/Components/MaterialIconProvider';
import { lockedIcon } from '../../../Assets/images/locked';
import { Link } from 'react-router-dom';
import MenuMaterialStatus from '../../Material/Components/MenuMaterialStatus';
import { Tooltip } from 'react-tippy';
import { useTranslation } from 'react-i18next';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

type SearchResultItemsProps = {
  items: Array<SearchMaterial>;
  getMaterialUrl: (chapterId: string, materialId: string) => string;
};

const SearchResultItems: React.FunctionComponent<SearchResultItemsProps> = ({
  items,
  getMaterialUrl,
}): React.ReactElement => {
  const { t } = useTranslation();
  let exactMatch = true;
  let exactMatches = 0;
  return (
    <div className="search-items">
      {items.map((material: SearchMaterial) => {
        if (material.exactMatch) {
          exactMatches++;
        }

        const showSimilarLabel =
          exactMatch === true && material.exactMatch === false;
        exactMatch = material.exactMatch;
        const [courseData] = material.courses;
        const label = (
          <div>
            <span>
              {`${courseData.moduleName}`}
              &nbsp;
              <FontAwesomeIcon icon={faChevronRight} />
              &nbsp;
              {`${courseData.chapterName}`}
            </span>
          </div>
        );

        return (
          <>
            {exactMatches === 0 && showSimilarLabel && (
              <div className={'search-not-found'}>
                <span>{t('Exact results not found.')}</span>
              </div>
            )}
            {showSimilarLabel && (
              <div className={'search-not-found'}>
                <span>{t('Similar search results')}</span>
              </div>
            )}
            {material.disabled ? (
              <MaterialItemDisabled key={material.id}>
                <div className="material-label">
                  <MaterialIconProvider material={material} />
                  <Tooltip
                    position="right"
                    html={t('Available later in the course')}
                  >
                    <div className="material-label-text">
                      <div className="material-label-header">
                        <span>{label}</span>
                      </div>
                      <div>
                        <span>{material.name}</span>
                      </div>
                    </div>
                  </Tooltip>
                </div>
                {lockedIcon}
              </MaterialItemDisabled>
            ) : (
              <MaterialItem
                key={material.id}
                as={Link}
                to={getMaterialUrl(courseData.chapterId, material.id)}
              >
                <div className="material-label">
                  <MaterialIconProvider material={material} />
                  <div className="material-label-text">
                    <div className="material-label-header">
                      <span>{label}</span>
                    </div>
                    <div>
                      <span>{material.name}</span>
                    </div>
                  </div>
                </div>
                <MenuMaterialStatus status={material.status} />
              </MaterialItem>
            )}
          </>
        );
      })}
    </div>
  );
};

export default SearchResultItems;
